<template>
  <section class="interface">
    <Profile/>
    <section class="title">
      <h1><i class="icon-account"></i>MODIFIER MON PROFIL</h1>
    </section>
    <form @submit.prevent="edit()">
    <section class="grid add">
      <section class="card new">
        <h2>Informations</h2>
        <section>
          <p>
            <label for="gender">Genre</label>
            <select id="gender" v-model="account.gender">
              <option value="0">Aucun</option>
              <option value="1">Homme</option>
              <option value="2">Femme</option>
            </select>
            <i class="icon-select"></i>
          </p>
        </section>
        <section>
          <p>
            <label for="firstname">Prénom</label>
            <input type="text" id="firstname" v-model="account.firstname" />
          </p>
        </section>
        <section>
          <p>
            <label for="lastname">Nom</label>
            <input type="text" id="lastname" v-model="account.lastname" />
          </p>
          </section>
        <section>
          <p>
            <label for="mail">Email</label>
            <input type="text" id="mail" v-model="account.email" />
          </p>
        </section>
        <section>
          <p>
            <label for="compagny">Société</label>
            <input type="text" id="compagny" v-model="account.compagny" />
          </p>
        </section>
        <section>
          <p>
            <label for="birthday">Date de naissance</label>
            <v-date-picker id="birthday" v-model="account.birthday"
            :masks="{ input: 'DD/MM/YYYY' }"
            :model-config="{ type: 'number' }">
              <template #default="{ inputValue, inputEvents }">
                <input :value="inputValue" v-on="inputEvents" />
              </template>
            </v-date-picker>
          </p>
        </section>
      </section>
      <section class="card new">
        <h2>Coordonnées</h2>
        <section>
          <p>
            <label for="adress">Adresse</label>
            <input type="text" id="adress" v-model="account.contact.address" />
          </p>
        </section>
        <section>
          <p>
            <label for="city">Ville</label>
            <input type="text" id="city" v-model="account.contact.city" />
          </p>
        </section>
        <section>
          <p>
            <label for="zip">Code postal</label>
            <input type="text" id="zip" v-model="account.contact.zipcode" />
          </p>
        </section>
        <section>
          <p>
            <label for="phone">Téléphone</label>
            <input type="text" id="phone" v-model="account.contact.phone" />
          </p>
        </section>
        <section>
          <p>
            <label for="mobile">Mobile</label>
            <input type="text" id="mobile" v-model="account.contact.mobile" />
          </p>
        </section>
      </section>
      <section class="card new">
        <h2>Préférences</h2>
        <section class="table by3">
          <ul>
            <li class="stickyLabel"><label>LOT</label><label>PRIX</label><label>STAT</label></li>
            <li class="card td" :class="{ 'cl0' : account.menu.linecolor }"><span>LOT 1</span><span>180000</span><span class="badge status st0">Disponible</span></li>
            <li class="card td" :class="{ 'cl1' : account.menu.linecolor }"><span>LOT 2</span><span>155000</span><span class="badge status st1">Optionné</span></li>
            <li class="card td" :class="{ 'cl2' : account.menu.linecolor }"><span>LOT 3</span><span>125000</span><span class="badge status st2">Réservé</span></li>
            <li class="card td" :class="{ 'cl3' : account.menu.linecolor }"><span>LOT 4</span><span>133000</span><span class="badge status st3">Financé</span></li>
            <li class="card td" :class="{ 'cl4' : account.menu.linecolor }"><span>LOT 5</span><span>128000</span><span class="badge status st4">Acté</span></li>
          </ul>
        </section>
        <hr />
        <ul class="column">
          <li>
            <label for="color">
              <input type="checkbox" class="toggle" id="color" @click="color()" v-model="account.menu.color" /> Palette de couleur
            </label>
          </li>
          <li>
            <label for="linecolor">
              <input type="checkbox" class="toggle" id="linecolor" v-model="account.menu.linecolor" /> Remplissage couleur ligne
            </label>
          </li>
          <li>
            <label for="display">
              <input type="checkbox" class="toggle" id="display" @click="display()" v-model="account.menu.display" /> Affichage compact
            </label>
          </li>
          <li>
            <label for="side">
              <input type="checkbox" class="toggle" id="side" @click="menu()" v-model="account.menu.side" /> Menu icône
            </label>
          </li>
        </ul>
      </section>
      <section v-if="isAdmin" class="card"><small>Data.json</small>
        <pre class="scroll">
          {{account}}
        </pre>
      </section>
    </section>
    <section class="card">
      <p>
        <button type="submit">MODIFIER</button>
      </p>
    </section>
    </form>
  </section>
</template>

<script>
import Profile from '@/components/Profile.vue'

export default {
  name: 'ProfilEdit',
  components: {
    Profile
  },
  computed: {
    meta: function () {
      return this.$store.getters.meta
    },
    isAdmin: function () {
      return this.$store.getters.isAdmin
    }
  },
  data () {
    return {
      account: {},
      phone: '',
      mobile: ''
    }
  },
  created () {
    this.account = JSON.parse(JSON.stringify(this.meta))
    this.account.contact.phone = this.$options.filters.phone(this.account.contact.phone)
    this.account.contact.mobile = this.$options.filters.phone(this.account.contact.mobile)
  },
  methods: {
    edit: function () {
      // phone formated to string (ex:#0298571020)
      this.account.contact.phone = '#' + this.account.contact.phone.split('.').join('').split(' ').join('').split('#').join('')
      this.account.contact.mobile = '#' + this.account.contact.mobile.split('.').join('').split(' ').join('').split('#').join('')
      // set update from edit profile
      const payload = {
        login: false,
        meta: this.account
      }
      this.$store.dispatch('updateMyProfile', payload)
        .then(() => {
          this.$store.dispatch('getUser')
            .then(() => {
              this.$store.dispatch('fetchMyProfile')
                .then(() => {
                  var mess = 'User profile updated!'
                  this.$store.commit('status_success', mess)
                  this.$router.push('/')
                })
                .catch()
            })
            .catch((err) => { this.messages = err.status })
        })
        .catch()
    },
    // set original status color
    color: function () {
      const root = document.documentElement
      if (!this.account.menu.color) {
        // dar-blue blue dark-yellow
        root.style.setProperty('--reserved', '#d9b600')
        root.style.setProperty('--financed', '#0254a2')
        root.style.setProperty('--acted', '#01396f')
        root.style.setProperty('--reserved-rgb', '#e6cd5b')
        root.style.setProperty('--financed-rgb', '#b8d2f4')
        root.style.setProperty('--acted-rgb', '#81b2ef')
      } else {
        // red cyan green
        root.style.setProperty('--reserved', '#33d4e8')
        root.style.setProperty('--financed', '#6ddc76')
        root.style.setProperty('--acted', '#f34f7d')
        root.style.setProperty('--reserved-rgb', '#b1eef6')
        root.style.setProperty('--financed-rgb', '#c1f0c5')
        root.style.setProperty('--acted-rgb', '#fcd4df')
      }
    },
    // set size of side menu
    menu: function () {
      const main = document.querySelector('main')
      if (!this.account.menu.side) main.classList.add('menulock')
      else main.classList.remove('menulock')
    },
    // set table text density display
    display: function () {
      const body = document.body
      if (!this.account.menu.display) body.classList.add('compact')
      else body.classList.remove('compact')
    }
  }
}
</script>
